import { useEffect } from 'react';

const ACTIVE_TITLE   = 'Der Dividenden-Investor | Marc Arndt';
const INACTIVE_TITLE = 'Kommen Sie zurück zum Cashflow! 📈';

export function useTabTitle() {
  useEffect(() => {
    const handleVisibilityChange = () => {
      document.title = document.hidden ? INACTIVE_TITLE : ACTIVE_TITLE;
    };

    // Set the initial title
    document.title = ACTIVE_TITLE;

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);
}